<div class="full-screen">
    <iframe title="Dashboard" width="100%" height="100%" src="https://app.powerbi.com/view?r=eyJrIjoiNmE3ODI3ZTctMmJkZi00OGIwLWE4ODgtM2I5NDg1MWQ1YWUyIiwidCI6ImNhOTU1NmFlLWRlZTAtNDRmNy1hYWZiLWVjODYwMGU0YmI5NSJ9&pageName=ReportSection" frameborder="0" allowFullScreen="true"></iframe>
</div>